import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCaseContext } from '../context/CaseContext';
import '../mobile.css';

const Section = ({ title, children }) => {
  if (!children) return null;
  return (
    <div style={{ marginBottom: '16px' }}>
      <div style={{ fontWeight: 700, color: '#094268', marginBottom: '4px' }}>{title}</div>
      <div style={{ textAlign: 'justify' }}>{children}</div>
    </div>
  );
};

const ObjectList = ({ title, obj }) => {
  if (!obj || Object.keys(obj).length === 0) return null;
  return (
    <div style={{ marginBottom: '16px' }}>
      <div style={{ fontWeight: 700, color: '#094268', marginBottom: '4px' }}>{title}</div>
      {Object.entries(obj).map(([key, value]) => (
        <div key={key} style={{ marginBottom: '4px' }}><b>{key}: </b>{String(value)}</div>
      ))}
    </div>
  );
};

const MobileGeneratedCS = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fullFIR } = useCaseContext();
  const fir = location.state?.fir || fullFIR;
  const caseDiary = fir?.caseDiary;

  if (!fir || !caseDiary) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No generated charge sheet available yet.</p>;

  const isComplete = Boolean(caseDiary.caseRegistrationFacts) && Array.isArray(caseDiary.investigationConducted) && caseDiary.investigationConducted.length > 0 && Boolean(caseDiary.conclusion);

  return (
    <div style={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
      <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#094268', marginBottom: '15px' }}>Generated Charge Sheet</h2>

      {!isComplete && <p style={{ color: '#E53935', marginBottom: '15px' }}>Charge sheet generation is still processing.</p>}

      <Section title="Case Registration Facts">{caseDiary.caseRegistrationFactsTranslated || caseDiary.caseRegistrationFacts}</Section>

      {Array.isArray(caseDiary.investigationConducted) && caseDiary.investigationConducted.length > 0 && (
        <div style={{ marginBottom: '16px' }}>
          <div style={{ fontWeight: 700, color: '#094268', marginBottom: '4px' }}>Investigation Conducted</div>
          {(caseDiary.investigationConductedTranslated || caseDiary.investigationConducted).map((item, i) => (
            <div key={i} style={{ marginBottom: '4px', textAlign: 'justify' }}>{i + 1}. {item}</div>
          ))}
        </div>
      )}

      <Section title="Conclusion">{caseDiary.conclusionTranslated || caseDiary.conclusion}</Section>

      <ObjectList title="Role of Accused" obj={caseDiary.roleOfAccused} />
      <ObjectList title="Gaps in Role of Accused" obj={caseDiary.roleOfAccusedGaps} />
      <ObjectList title="Offenses and Sections" obj={caseDiary.offensesAndSections} />
      <ObjectList title="Witnesses" obj={caseDiary.witnesses} />
      <ObjectList title="Gaps in Witnesses" obj={caseDiary.witnessesGaps} />
      <ObjectList title="Evidences" obj={caseDiary.evidences} />
      <ObjectList title="Gaps in Evidences" obj={caseDiary.evidencesGaps} />

      <button
        className="m-button-primary"
        style={{ width: 'auto', padding: '10px 16px', marginTop: '10px' }}
        onClick={() => navigate('/m/fir/casediary/new', { state: { fir } })}
      >
        Regenerate
      </button>
    </div>
  );
};

export default MobileGeneratedCS;
